import { Link } from "react-router-dom"

export const Breadcrumb = ({current}) => {
  return (
    <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to={process.env.PUBLIC_URL+'/'}>Inicio</Link></li>
          <li className="breadcrumb-item active" aria-current="page">{current}</li>
      </ol>
    </nav>
  )
}
